import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["option", "children"];
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
const VariantSelectValue = _ref => {
  let {
      option,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return option !== null && option !== void 0 && option.text ? /*#__PURE__*/_jsx(TruncateString, Object.assign({
    useFlex: true,
    "data-test-id": "variant-select-value"
  }, rest, {
    children: option.text
  })) : children;
};
export default VariantSelectValue;